import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Header from "../components/Layout/header";
import Footer from "../components/Layout/footer";
import MultiLayerParallax from '../components/UI/MultiLayerParallax.tsx'

export default function Contact() {
  const form = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  // Function to send email
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_v3n4nhw", "template_yeb1bgb", form.current, {
        publicKey: "0iLC8EJLRT_tIHWIx",
      })
      .then(
        () => {
          setModalMessage("Message sent successfully!");
          setIsOpen(true);
        },
        (error) => {
          setModalMessage(
            "Failed to send message, please try again. " + error.text
          );
          setIsOpen(true);
        }
      );
    e.target.reset();
  };

  return (
    <div className="bg-neutral-100">
      <Header />
      <MultiLayerParallax />
      <div className="isolate bg-white px-6 py-14 sm:py-24 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Interested in working together?
          </h2>
        </div>
        <form
          ref={form}
          onSubmit={sendEmail}
          className="mx-auto mt-16 max-w-xl sm:mt-20"
        >
          <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
            {/** First Name Field **/}
            <InputField
              label="First name"
              type="text"
              name="first_name"
              id="first-name"
              required
            />
            {/** Last Name Field **/}
            <InputField
              label="Last name"
              type="text"
              name="last_name"
              id="last-name"
              required
            />
            {/** Email Field **/}
            <InputField
              label="Email"
              type="email"
              name="email"
              id="email"
              required
              colSpan="sm:col-span-2"
            />
            {/** Message Field **/}
            <TextAreaField
              label="Message"
              name="message"
              id="message"
              rows="4"
              required
              colSpan="sm:col-span-2"
            />
          </div>
          <div className="mt-10">
            <button
              type="submit"
              className="block w-full rounded-md bg-brand-blue px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-brand-lightBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-blue"
            >
              Let's talk
            </button>
          </div>
        </form>

        {/** Modal for message feedback **/}
        {isOpen && (
          <Modal message={modalMessage} onClose={() => setIsOpen(false)} />
        )}
      </div>
      <Footer />
    </div>
  );
}

// Reusable Input Field Component
const InputField = ({ label, type, name, id, required, colSpan }) => (
  <div className={colSpan || ""}>
    <label htmlFor={id} className="block text-sm font-semibold leading-6 text-gray-900">
      {label}
    </label>
    <div className="mt-2.5">
      <input
        type={type}
        name={name}
        id={id}
        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        required={required}
      />
    </div>
  </div>
);

// Reusable Text Area Field Component
const TextAreaField = ({ label, name, id, rows, required, colSpan }) => (
  <div className={colSpan || ""}>
    <label htmlFor={id} className="block text-sm font-semibold leading-6 text-gray-900">
      {label}
    </label>
    <div className="mt-2.5">
      <textarea
        name={name}
        id={id}
        rows={rows}
        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        required={required}
      />
    </div>
  </div>
);

// Reusable Modal Component for message feedback
const Modal = ({ message, onClose }) => (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-md">
      <p>{message}</p>
      <button
        onClick={onClose}
        className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
      >
        Close
      </button>
    </div>
  </div>
);
